import React from 'react'
import { connect } from 'react-redux'
import { map } from 'lodash/collection'
import KeyValue from '../KeyValue'
import { isAnURL } from 'lib/validator'
import style from './index.scss'
import c from 'state/constants'


import i18n from 'lib/i18n'
const _ = i18n('office')
import { showLoader, hideLoader } from 'state/actions'
import MifidButton from '../DSDocuments/mifidButton'

@connect(state => {
	const hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false

	return {
		broker: state.office.brokers[state.app.brNr],
		brokerNumber: state.app.brNr,
		hasInternalAccess
	}
})
export default class General extends React.Component {
	static propTypes = {
		broker: React.PropTypes.object,
		brokerNumber: React.PropTypes.string,
	}

	constructor(props) {
		super(props)
		this.state = { logoRefreshed: true, randomNumber: this.getRandom() }
	}

	getRandom() {
		return Math.floor(Math.random() * 100000000 + 1)
	}

	async refreshLogo(logoUrl) {
		const { dispatch } = this.props

		await dispatch(showLoader())
		this.setState({ logoRefreshed: false }, async () => {
			try {
				await new Promise((resolve, reject) => {
					let request = new XMLHttpRequest()

					request.open('GET', logoUrl, true)
					request.timeout = 10000
					request.onreadystatechange = () => {
						if (request.readyState === 4) {
							if (request.status === 404) {
								resolve(logoUrl)
							} else if (request.status === 200) {
								resolve(logoUrl)
							} else {
								// anyway do a refresh in dome
								resolve(logoUrl)
							}
						}
					}
					request.ontimeout = () => {
						resolve(logoPlaceholderUrl)
					}
					request.send()
				})
			} catch (err) {
				console.error("Refreshing logo error: ", err)
			}

			// end of refresh procedure
			this.setState({ logoRefreshed: true, randomNumber: this.getRandom() }, async () => {
				await dispatch(hideLoader())
			})
		})
	}

	render() {
		const { broker, brokerNumber, hasInternalAccess } = this.props
		const { logoRefreshed, randomNumber } = this.state

		if (!broker || !broker.main) { return false }
		const main = broker.main
		const address = main.mainAddress
		const correspondence = main.correspondanceAddress

		const fullAddress = (address) => (`${address.street} ${address.number} ${address.extension} ${address.postalCode} ${address.locality}`)

		const website = (url) => {
			return isAnURL(url) ? <a href={url} target="_blank"rel="noopener noreferrer">{url} </a> : url
		}

		const ibans = map(main.accountNumbers, (accountNumber, i) =>
			<span key={i}>
				{accountNumber.IBAN}
			</span>
		)

		const emails = map(main.emails, (email, i) =>
			<a key={i} href={`mailto:${email}`}>
				{email}
			</a>
		)

		const phoneNumbers = map(main.phoneNumbers, (phoneNumber, i) =>
			<a key={i} href={`tel:${phoneNumber}`}>
				{phoneNumber}
			</a>
		)

		const fax = (<a href={`tel:${main.faxNumber}`}>
			{main.faxNumber}
		</a>)

		const columns = [
			[
				{ label: _('name'), value: main.name },
				{ label: _('commercialName'), value: main.commercialName },
				{ label: _('email'), value: emails },
				{ label: _('adres'), value: fullAddress(address) },
				{ label: _('iban'), value: ibans },
				{ label: _('companyRegistrationNumber'), value: main.companyRegistrationNumber },
				{ label: _('contract'), value: main.contract },
				{ label: _('aedesNumber'), value: main.aedesNumber },
			],
			[
				{ label: _('website'), value: website(main.website) },
				{ label: _('telephone'), value: phoneNumbers },
				{ label: _('fax'), value: fax },
				{ label: _('brokerType'), value: main.brokerType },
				{ label: _('correspondance'), value: fullAddress(correspondence) },
				{ label: _('fsma'), value: main.fsmaNumber },
			],
		]

		const logoUrl = "/brokerLogo?brokerNumber=" + brokerNumber + "&randomNumber=" + this.state.randomNumber
		const logoUrlNoCache = "/brokerLogo?brokerNumber=" + brokerNumber + "&noCache=1"

		return (
			<div>
				<div className={style.logoAndButtonContainer}>
					<span className={style.containerForLogo}>
						<a className={style.brokerLogoContainer} href={logoUrl} target="_blank" rel="noopener noreferrer"><img className={style.brokerLogo} src={logoUrl} /></a>
					</span>
					<span className={style.containerForButton}>
						<button className={style.greyButton} onClick={(() => { return this.refreshLogo(logoUrlNoCache) }).bind(this)}>{_("refreshLogo")}</button>
						{hasInternalAccess && brokerNumber &&
							<div className={style.DSWizardButtonWrapper}>
								<MifidButton
									moduleKeyToSet={c.DS_MODULE_OFFICE}
									subModuleKeyToSet={c.DS_MODULE_OFFICE}
									brokerFromOffice={broker}
									// brokerId={clientId}
									// claimId={claimId}
									// claimNumber={claimNumber}
									callBackOnClose={() => { }}
								// moduleOptions={this.collectVariableValues()}
								/>
							</div>
						}
						{/* <label className={style.refreshLogoDescription}>{_("refreshBrokerLogoDescription")}</label> */}
					</span>
				</div>
				<KeyValue array={columns} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/General.jsx